<script setup lang="ts"></script>

<template>
  <picture>
    <source
      srcset="../assets/ai-icon.webp"
      type="image/webp"
    >
    <source
      srcset="../assets/ai-icon.png"
      type="image/png"
    >
    <img
      :class="$style.icon"
      src="../assets/ai-icon.png"
      alt=""
    >
  </picture>
</template>

<style module>
.icon {
  width: 100%;
  height: 100%;
}
</style>

<i18n lang="json">{}</i18n>
